<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>
  // Styles
  import '@/styles/overrides.sass'

  export default {
    name: 'App',
    metaInfo: {
      title: 'MPI',
      titleTemplate: '%s | MMSystem',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
  }
</script>
<style>
  .v-btn{
    box-shadow: none !important
  }
  .v-application .elevation-6 {
    box-shadow: none !important    
  }
  #default-drawer {
    margin-left: 0px !important 
  }
 .v-list-item__icon:first-child {
    margin-right: 10px !important 
  }
  .v-list--nav {
      padding: 0px !important 
  }
  tbody tr:nth-child(even):hover {
    background-color: #f5f5f5 !important;
    /*background-color: transparent !important;*/
  }
  tbody tr:nth-child(odd):hover {
    background-color: #FFF !important;
    /*background-color: transparent !important;*/
  }
  tr:nth-child(even) {
  background: #f5f5f5
  }
  tr:nth-child(odd) {
    background: #FFF
  }
  .v-navigation-drawer/*, .v-main */{
    transition-duration: 1s !important;
  }
  .v-main {
    padding: 70px 0px 0px 80px !important;
  }
  .container {
    padding: 0px !important;
  }
  @media (min-width: 1264px){
    .container {
      max-width: 1750px !important;
    }
  }
  /*.ok-button {
    color:#ffffff;
    background-color:#31c0be;
  }
  .cancel-button {
    color:#757575;
  }*/
  /*.v-overlay__scrim {
    opacity:0.4 !important;
  }*/
</style>